import { z } from 'zod';

export const AccessSchema = z.object({
    guests: z.array(z.object({ id: z.number() })).default([]),
});
